import TECheckboxInput from './TECheckboxInput'

export default TECheckboxInput
